import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, Navigate, useParams } from 'react-router-dom'

import { LightThemeProvider } from '@qflow/theme'

import { Home } from 'portal/components/Home'
import { Sidebar } from 'portal/components/Sidebar'
import { PageContainer } from 'portal/pages/PageContainer'
import * as ROUTES from 'portal/routes'

import { accountLoad } from 'portal/store/accountDetails/actions'
import { selectGlobalDate } from 'portal/store/global/selectors'

const globalDateSelector = selectGlobalDate()

export const HomePage = () => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string | undefined
  }>()

  const { startDate, endDate } = useSelector(globalDateSelector)

  useEffect(() => {
    dispatch(accountLoad(accountId))
  }, [accountId, dispatch])

  const projects = useSelector((state: any) => state.projects)

  // If no projectId in the URL, redirect to the first project
  if (projects.projects?.length > 0 && !projectId) {
    const firstProjectId = projects.projects[0].projectId
    return (
      <Navigate
        to={generatePath(ROUTES.HOMEPAGE, {
          accountId: accountId ?? null,
          projectId: firstProjectId
        })}
      />
    )
  } else if (projects.projects?.length === 0 && !projectId) {
    // If there are no projects, redirect to the Dashboard page,
    // which will handle any other redirection logic.
    return (
      <Navigate
        to={generatePath(ROUTES.BI_REPORT, {
          accountId: accountId || null,
          reportType: 'dashboard'
        })}
      />
    )
  }

  return (
    <LightThemeProvider>
      <Sidebar />
      <PageContainer>
        <Home startDate={startDate} endDate={endDate} />
      </PageContainer>
    </LightThemeProvider>
  )
}
